import { Role } from '../models/role.model';

export const MENU_ITEMS: Record<Role, any[]> = {
  Admin: [
    { label: 'Manage Products', route: '/admin/products' },
    //{ label: 'Add Product', route: '/admin/CreateProduct' },
    { label: 'Add Product', route: '/admin/categories' },
    //{ label: 'Add Category', route: '/admin/categories/create' },
    
    {
      label: 'Dashboard',
      route: '/dashboard',
      children: [
        { label: 'Overview', route: '/dashboard/overview' },
        { label: 'Vendors', route: '/dashboard/vendors' },
        { label: 'Users', route: '/dashboard/users' },
        { label: 'Orders', route: '/dashboard/orders' }
      ]
    }
  ],
  Vendor: [
    {
      label: 'Dashboard',
      route: '/dashboard',
      children: [
        { label: 'Overview', route: '/dashboard/overview' }
      ]
    },
    { label: 'Shop Now', route: '/shop' },
    { label: 'My Products', route: '/dashboard/products' },
    { label: 'My Orders', route: '/dashboard/orders' }

  ],
  User: [
    { label: 'Shop Now', route: '/shop' },
    { label: 'My Orders', route: '/my-orders' }

  ]
};


